import { render, staticRenderFns } from "./LSPILogin.vue?vue&type=template&id=64762b1a"
import script from "./LSPILogin.vue?vue&type=script&lang=js"
export * from "./LSPILogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports